import { normalizeNumberVariableDecimal } from "components/FormElements/normalizeInteger";

export const normalizeMoney = value => {
  if (!value)
    return value;
  const onlyNums = value.replace(/[^\d,.]/g, "");
  if (onlyNums.length <= 10) {
    return onlyNums;
  }
};

export const normalizeIntegerMoney = v => v && parseInt(`${v}`.replace(/[^\d]/g, "").substring(0, 13)).toLocaleString("en-US", { style: "currency", currency: "USD" }).slice(0, -3);

//doesnt rely on any parse float or int so it can support any size numbers.... bad idea? who knows
export const normalizeDecimalMoney = (value, previousValue) => {
  value = normalizeNumberVariableDecimal(2)(value, previousValue);
  return value.length ? "$" + value : "";
};